import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import save from "assets/icon/save.svg";
import Cancel from "assets/icon/CancelIcon-manufacture.svg";

import Loader from 'components/Loader';

const Confirm = (props) => {
  const { isOpen, message, loading, onToggle, onContinue, onCancel } = props;
  return (
    <Modal centered isOpen={isOpen} toggle={onToggle}>
    <ModalBody className="m-2 p-4">
      {loading && <Loader />}
      <h6 className="f-24 ">Confirmation!</h6>
      <p className="f-14 font-weight-400">{message}</p>
      <div className="text-end pt-4">
        <Button color="cancel" className="reset" outline onClick={onCancel}>
          <span className="right_5">
            <img src={Cancel} alt="" />
          </span>{" "}
          Cancel
        </Button>
        <Button color="primary" className="search" onClick={onContinue}>
          <span className="right_5">
            <img src={save} alt="" />
          </span>{" "}
          Proceed
        </Button>
      </div>
    </ModalBody>
  </Modal>
  );
};

export default Confirm;
